import { useId, type ReactNode } from 'react';
import styles from './Feedback.module.css';

const HEADING_TAG = { 2: 'h2', 3: 'h3', 4: 'h4' } as const;

export function ErrorState({
  title,
  body,
  action,
  headingLevel = 2,
}: {
  title: string;
  body: ReactNode;
  action?: ReactNode;
  headingLevel?: 2 | 3 | 4;
}): ReactNode {
  const titleId = useId();
  const Heading = HEADING_TAG[headingLevel];

  return (
    <section
      className={styles.errorState}
      role="alert"
      aria-labelledby={titleId}
    >
      <span className={styles.mark} aria-hidden="true">
        !
      </span>
      <div className={styles.content}>
        <Heading id={titleId} className={styles.title}>
          {title}
        </Heading>
        <p className={styles.body}>{body}</p>
        {action ? <div className={styles.action}>{action}</div> : null}
      </div>
    </section>
  );
}
